import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Badge, Dropdown, type MenuProps } from 'antd';
import type { FC } from 'react';
import { useHighlightedTrackers } from '../../../lib/customHooks';
import { IconArrowsUpDown, IconEmail, IconSquareCheck, IconTag } from '../../Icon';
import { SendMessagesToTrackerButton } from '../ActionsDropDown/SendMessagesToTrackerButton';
import { AddHighlightedTrackersToSelectionButton } from './AddHighlightedTrackersToSelectionButton';
import { AddHighlightedTrackersToTagButton } from './AddHighlightedTrackersToTagButton';

export const ActionsDropDownHighlightedTrackers: FC = () => {
  const highlightedTrackers = useHighlightedTrackers();
  const items: MenuProps['items'] = [
    {
      key: 'count-highlighted-trackers',
      label: (
        <div>
          <b>{highlightedTrackers.length}</b> highlighted tracker
          {highlightedTrackers.length > 1 ? 's' : ''}
        </div>
      ),
    },
    {
      type: 'divider',
    },
    {
      icon: <IconTag />,
      key: 'add-tracker-to-tag-event',
      label: <AddHighlightedTrackersToTagButton />,
    },
    {
      icon: <IconArrowsUpDown />,
      key: 'add-tracker-to-selection-event',
      label: <AddHighlightedTrackersToSelectionButton />,
    },
    {
      icon: <IconEmail />,
      key: 'send-message-to-tracker',
      label: <SendMessagesToTrackerButton trackersToUse={highlightedTrackers} />,
    },
  ];

  return (
    <Dropdown menu={{ items }}>
      <StyledIconWithBadge>
        <Badge
          count={highlightedTrackers.length}
          size={'small'}
          offset={[2, 3]}
          color={RacemapColors.PaleBlue}
        >
          <StyledIconSquareCheck />
        </Badge>
      </StyledIconWithBadge>
    </Dropdown>
  );
};

const StyledIconSquareCheck = styled(IconSquareCheck)`
  height: 17px;
  color: ${RacemapColors.PaleBlue} !important;
`;

const StyledIconWithBadge = styled.div`
  padding-right: 13px;
`;
